import { render, staticRenderFns } from "./CategoriesModal.vue?vue&type=template&id=f3cc2300&scoped=true&"
import script from "./CategoriesModal.vue?vue&type=script&lang=js&"
export * from "./CategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesModal.vue?vue&type=style&index=0&id=f3cc2300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cc2300",
  null
  
)

export default component.exports